// extracted by mini-css-extract-plugin
export default {"text":"breadcrumbs-item_text__eBdLo","link":"breadcrumbs-item_link__TuE31","active":"breadcrumbs-item_active__Dlji+"};